import React from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans text-gray-100 selection:bg-brand-red selection:text-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main className="pt-14" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <ModulesSection data-id="element-5" />
        <Testimonials data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}